import { Th, Thead, Tr } from "@chakra-ui/react";

export const TargetedProvidersColumnHeaders: React.FC<{ showSwitch?: boolean }> = (
  {showSwitch = true}
) => (
  <Thead>
    <Tr>
      <Th>Provider list</Th>
      {showSwitch &&
        <Th textAlign="right">Opted in</Th>
      }
    </Tr>
  </Thead>
);
